import apiClient from "@/utils/apiClient";

const serviceService = {
  // 🔥 GET ALL SERVICES (FILTER SUPPORT)
  getAll: async (params = {}) => {
    try {
      const res = await apiClient.get("/services", { params });
      return res.data?.data || [];
    } catch (err) {
      console.error("getAll services error:", err);
      throw err;
    }
  },

  // 🔥 GET SERVICES BY BOOKING (TripDetails use)
  getByBooking: async (bookingId) => {
    try {
      const res = await apiClient.get(`/services/booking/${bookingId}`);
      return res.data?.data || [];
    } catch (err) {
      console.error("getByBooking error:", err);
      throw err;
    }
  },

  // 🔥 CREATE SERVICE
  create: async (data) => {
    try {
      const res = await apiClient.post("/services", data);
      return res.data?.data;
    } catch (err) {
      console.error("create service error:", err);
      throw err;
    }
  },

  // 🔥 UPDATE STATUS (hotel lifecycle)
  updateStatus: async (id, status) => {
    try {
      const res = await apiClient.put(`/services/${id}/status`, { status });
      return res.data?.data;
    } catch (err) {
      console.error("updateStatus error:", err);
      throw err;
    }
  },

  // 🔥 SEND EMAIL (optional automation)
  sendEmail: async (id) => {
    try {
      const res = await apiClient.post(`/services/${id}/send-email`);
      return res.data?.data;
    } catch (err) {
      console.error("sendEmail error:", err);
      throw err;
    }
  },

  // 🔥 BULK STATUS UPDATE (future-ready)
  bulkUpdateStatus: async (ids = [], status) => {
    try {
      const res = await apiClient.put("/services/bulk-status", {
        ids,
        status,
      });
      return res.data?.data;
    } catch (err) {
      console.error("bulkUpdateStatus error:", err);
      throw err;
    }
  },

  // 🔥 BULK EMAIL (future SaaS feature)
  bulkSendEmail: async (ids = []) => {
    try {
      const res = await apiClient.post("/services/bulk-email", { ids });
      return res.data?.data;
    } catch (err) {
      console.error("bulkSendEmail error:", err);
      throw err;
    }
  },
};

export default serviceService;
